export default __webpack_public_path__ + "static/media/bag.c7fe23e1.svg";